import { render, staticRenderFns } from "./modal-shell.vue?vue&type=template&id=852b8fec&scoped=true"
import script from "./modal-shell.vue?vue&type=script&lang=js"
export * from "./modal-shell.vue?vue&type=script&lang=js"
import style0 from "./modal-shell.vue?vue&type=style&index=0&id=852b8fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852b8fec",
  null
  
)

export default component.exports